import { render } from "./DatabaseProductEdit.vue?vue&type=template&id=b7ba06f2"
import script from "./DatabaseProductEdit.vue?vue&type=script&lang=js"
export * from "./DatabaseProductEdit.vue?vue&type=script&lang=js"

import "./DatabaseProductEdit.vue?vue&type=style&index=0&id=b7ba06f2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__